import DCFCardAsLink from '@dcf/js/components/dcf-card-as-link.js';
export default class UNLCardAsLink extends DCFCardAsLink {
    constructor(card, options = {}) {
        super(card, options);
    }
}
